import React from "react";
import { CountryDropdown } from "react-country-region-selector";
import { connect } from "react-redux";
import { userType } from "../../../../utils/postgraphile";

interface Props {
    id: string;
    name: string;
    labelText: string;
    country: string;
    selectCountry: (val: string) => void;
    required?: boolean;
    isInvalid?: boolean | string;
    currentUser?: any;
    valueType?: "full" | "short";
}

function CountrySelectDropdown(props: Props) {
    const {
        id,
        name,
        labelText,
        country,
        selectCountry,
        required,
        isInvalid,
        currentUser,
        valueType = "short",
    } = props;

    return (
        <div className="from-group mb-3">
            <label htmlFor={id}>
                {labelText}
                {required ? <span className="text-danger">*</span> : ""}
            </label>
            <CountryDropdown
                id={id}
                name={name}
                classes={`form-control mb-0 ${isInvalid ? "is-invalid" : ""}`}
                valueType={valueType || "short"}
                value={country}
                onChange={(val) => {
                    selectCountry(val);
                }}
                whitelist={
                    currentUser.userType !== userType.SUPER_ADMIN &&
                    currentUser.userType !== userType.USER_MANAGER
                        ? currentUser.country
                        : undefined
                }
            />
            {isInvalid ? <div className="invalid-feedback">Invalid Value</div> : ""}
        </div>
    );
}

const mapStateToProps = (state: any) => {
    return {
        currentUser: state.users.currentUser,
    };
};
const mapDispatchToProps = (dispatch: any) => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(CountrySelectDropdown);
